import React from "react";
import { FaqAccordion } from "../../components";
import "./faq.css";

const Faq = () => {
  return (
    <div className="faq-page">
      <header className="faq-header">
        <h1>Frequently Asked Questions</h1>
        <p className="faq-subtitle">
          Everything you need to know about Talk2Coach — how it works, what it
          costs, and how to get the most out of every session.
        </p>
      </header>

      <FaqAccordion />
    </div>
  );
};

export default Faq;
